import { shouldFetchWaitingListCustomers } from './selectors';
import {
  FETCH_WAITING_LIST_CUSTOMERS,
  FETCH_WAITING_LIST_CUSTOMERS_ERROR,
  FETCH_WAITING_LIST_CUSTOMERS_SUCCESS,
} from './constants';
import Http from '../../../http';

const fetchWaitingListCustomersAction = () => ({ type: FETCH_WAITING_LIST_CUSTOMERS });
const fetchWaitingListCustomersErrorAction = () => ({ type: FETCH_WAITING_LIST_CUSTOMERS_ERROR });
const fetchWaitingListCustomersSuccessAction = (customers, day) => ({
  type: FETCH_WAITING_LIST_CUSTOMERS_SUCCESS,
  payload: {
    day,
    updatedAt: Date.now(),
    customers,
  },
});

const fetchWaitingListCustomers = (url, day) => (dispatch, getState) => {
  if (!shouldFetchWaitingListCustomers(getState(), day)) return null;

  dispatch(fetchWaitingListCustomersAction());

  return Http.get(url, { include: 'customer,services', sortBy: 'createdAt:asc' })
    .then(response => dispatch(fetchWaitingListCustomersSuccessAction(response, day)))
    .catch(() => dispatch(fetchWaitingListCustomersErrorAction()));
};

export const shopFetchWaitingListCustomers = (shopId, day) =>
  fetchWaitingListCustomers(`/shop/${shopId}/waiting-list/customer/${day}`, day);

export const barberFetchWaitingListCustomers = (barberId, day) =>
  fetchWaitingListCustomers(`/barber/${barberId}/waiting-list/customer/${day}`, day);
